/**
 * SmartActionShelf — chip row showing 9 instant smart actions on an extracted
 * OCR document. Pure presentational, extracted from OCRScanner.jsx for
 * readability + lower per-render cost (memoised mapping over SMART_ACTIONS).
 */
import { Loader2, Sparkles } from "lucide-react";

export default function SmartActionShelf({
  actions,
  activeTab,
  actionLoading,
  actionOutputs,
  onClick,
}) {
  return (
    <div className="tb-card p-4 sm:p-5 tb-fade-up" data-testid="smart-action-shelf">
      <div className="flex items-center justify-between mb-3">
        <p className="text-[10px] uppercase tracking-[0.25em] font-semibold text-primary inline-flex items-center gap-2">
          <Sparkles className="h-3 w-3" /> Smart actions
        </p>
        <p className="hidden sm:block text-[11px] text-muted-foreground">Tap any to generate instantly</p>
      </div>
      <div className="flex gap-2 overflow-x-auto tb-no-scrollbar -mx-1 px-1 pb-1 tb-stagger">
        {actions.map((a) => {
          const Icon = a.icon;
          const loading = actionLoading === a.key;
          const ready = !!actionOutputs[a.key];
          const active = activeTab === a.key;
          return (
            <button
              key={a.key}
              onClick={() => onClick(a.key)}
              className="tb-action-chip shrink-0"
              data-active={active ? "true" : "false"}
              data-loading={loading ? "true" : "false"}
              data-testid={`smart-action-${a.key}`}
              disabled={loading}
            >
              {loading ? (
                <Loader2 className="h-3.5 w-3.5 animate-spin" />
              ) : (
                <span className={`inline-grid place-items-center h-6 w-6 rounded-full ${a.chip}`}>
                  <Icon className="h-3.5 w-3.5" />
                </span>
              )}
              {a.label}
              {ready && !active && !loading && <span className="ml-1 inline-block h-1.5 w-1.5 rounded-full bg-emerald-500" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
